export default __webpack_public_path__ + "static/media/store_grey.c144ac97.svg";